import config from '../config';
import staticData from '../static_data/all';
import clientIdCustom from '../utils/tracking/clientIdCustom';
import { getGoogleAnalyticsClientIds } from '../utils/tracking/googleAnalytics';

export const CALL_API = process.env.REACT_APP_API_URL;

function callApi(endpoint, options) {
    const fullUrl =
        endpoint.indexOf(config.API_BASE_URL) === -1 && endpoint.indexOf('http') === -1
            ? config.API_BASE_URL + endpoint
            : endpoint;

    if (typeof fetch === 'undefined')
        return Promise.reject({ message: 'fetch is undefined' });

    return fetch(fullUrl, options).then(response =>
        response
            .text()
            .then(text => (text ? JSON.parse(text) : {}))
            .then(json => {
                if (!response.ok) {
                    return Promise.reject(json);
                }
                return json;
            })
    );
}

function addGlobalParams(request) {
    const adCampaign = staticData.useStatic ? 'CAMPAIGN_ID' : null;
    return {
        adCampaign,
        ...getGoogleAnalyticsClientIds(),
        clientIdCustom,
        ...request
    };
}

function post(endpoint, request) {
    return callApi(endpoint, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(addGlobalParams(request))
    });
}

function get(endpoint) {
    return callApi(endpoint, {
        method: 'GET',
        headers: {
            Accept: 'application/json'
        }
    });
}

export default {
    get,
    post
};
